import { ShaderMaterial, DoubleSide, FrontSide, GLSL3 } from 'three';
import {
  painterStrokeDefines,
  painterWarpDefines,
  surfaceDefines,
  type SharedUniforms,
} from './sharedUniforms';
import type { PaintedMaterialOptions } from '../types';
import {
  CLOTH_PAINTED_ATTRIBUTES,
  HEARTH_SMOKE_ATTRIBUTES,
  PAINTED_ATTRIBUTES,
  withProgramAttributes,
} from './programAttributes';
import { patternDefines, type PatternUniforms } from '../patterns/packPatterns';

import paintedVert from '../shaders/painted.vert?raw';
import paintedFrag from '../shaders/painted.frag?raw';

export function createPaintedMaterial(
  sharedUniforms: SharedUniforms,
  patternUniforms: PatternUniforms,
  options: PaintedMaterialOptions = {}
): ShaderMaterial {
  const material = new ShaderMaterial({
    glslVersion: GLSL3,
    vertexShader: paintedVert,
    fragmentShader: paintedFrag,
    defines: {
      ...painterWarpDefines(sharedUniforms),
      ...painterStrokeDefines(sharedUniforms),
      ...surfaceDefines(sharedUniforms),
      ...patternDefines(),
      ...(options.clothWind ? { USE_CLOTH_WIND: 1 } : {}),
      ...(options.hearthSmoke ? { USE_HEARTH_SMOKE: 1 } : {}),
    },
    uniforms: { ...sharedUniforms, ...patternUniforms },
    side: options.doubleSided ? DoubleSide : FrontSide,
    vertexColors: true,
    depthWrite: true,
    depthTest: true,
    colorWrite: !options.depthOnly,
  });

  material.userData['ams'] = true;

  return withProgramAttributes(
    material,
    options.hearthSmoke
      ? HEARTH_SMOKE_ATTRIBUTES
      : options.clothWind
        ? CLOTH_PAINTED_ATTRIBUTES
        : PAINTED_ATTRIBUTES
  );
}
